import '../styles/main.scss';

// import external dependencies
import $ from 'jquery';
import 'jquery-ui/ui/effect';

window.jQuery = window.$ = $;

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import './dva-effects/effects/drawer';
import './nav';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
$(() => routes.loadEvents());
library.add(fab, fas);
dom.watch();

/* Open */
$('#open-login').click(function () {
  $('#login-overlay').css('display', 'block');
});

$('.closelogin').click(function () {
  $('#login-overlay').css('display', 'none');
});
